import React, { useState, Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import GenericMessage from '../../../../../Components/GenericMessage/GenericMessage';
import MultipleFileUpload from '../../../../../Components/fileupload/MultipleFileUpload';
import FileInfo from '../../../../../Components/fileupload/FileInfo';
import './enrollment-upload-document.scss';

const UploadDocument = ({
  nextStep,
  prevStep,
  enrollmentFormData,
  setEnrollmentFormData,
}) => {
  console.log('UploadDocument enrollmentFormData', enrollmentFormData);
  const [files, setFiles] = useState(
    enrollmentFormData?.uploadedDocuments || [],
  );
  const [enrollmentFieldValue, setEnrollmentFieldValue] = useState(null);
  const onBackClickHandler = () => {
    if (
      enrollmentFormData &&
      enrollmentFormData.allNewlyAddedDependent.length > 0
    ) {
      prevStep();
    } else {
      prevStep(true);
    }
  };
  return (
    <div className="enrollment-upload-document-container">
      <div className="upload-document-info-header">
        <div>Upload Documents</div>
      </div>
      <div className="upload-document-content">
        <div className="paragraph-contnent">
          <p>
            Provide the necessary documents to complete your health insurance
            enrollment. Uploading the required documents ensures a smooth
            process and accurate coverage for you and your dependents.
          </p>
          <p>
            We take your privacy seriously. Your uploaded documents are
            encrypted and stored securely. They will only be used for
            verification and enrollment purposes.
          </p>
        </div>
        <div className="info-svg">
          <GenericMessage
            wrapperClasses="mt-4 mb-5"
            boldMessage="Please Note: "
            message="Providing accurate and complete documents will expedite the processing of your enrollment request. If you have any questions or need assistance, our support team is here to help."
            messageType={'info'}
            showMessage={true}
            hideCloseButton={true}
          />
        </div>
        <div>
          <MultipleFileUpload
            className=""
            files={files}
            setFiles={setFiles}
            name="file"
            setFieldValue={setEnrollmentFieldValue}
          />
        </div>
        <div>
          {files &&
            files.map((item, index) => {
              return (
                <Fragment key={index}>
                  <FileInfo
                    files={files}
                    setFiles={setFiles}
                    fileDetails={item}
                    filesLoader={false}
                    setFieldValue={setEnrollmentFieldValue}
                    readFileSize={true}
                  />
                </Fragment>
              );
            })}
        </div>
      </div>
      <div className="ml4 mr-4 pb-4">
        <Row>
          <Col className="d-flex justify-content-end">
            <GenericButton
              variant="link"
              onClick={() => {
                onBackClickHandler();
              }}
              className="form-btn"
            >
              Back
            </GenericButton>
            <GenericButton
              type="button"
              className="mr-0"
              onClick={() => {
                setEnrollmentFormData({
                  ...enrollmentFormData,
                  uploadedDocuments: files,
                });
                nextStep();
              }}
            >
              Continue
            </GenericButton>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default UploadDocument;
